'use client';
import type { FlexibleFormVariant } from './FlexibleFormBase';
import { isLicensePlateFormAsset } from './flexibleFormShared';
import { isPromoCodeFormField } from './promoCodeEntryValidation';
import { createPromoCodeCustomSubmit } from './promoCodeFlexibleFormSubmit';
import { createRflzCustomSubmit, getRequiredRflzFieldNames } from './rflzFlexibleFormSubmit';
import { createLicensePlateCustomSubmit } from './licensePlateFlexibleFormSubmit';

interface FlexibleFormCustomSubmitArgs {
    asset: SiteFlexibleForm;
    forceRflzSubmit?: boolean;
}

export function createFlexibleFormCustomSubmit({
    asset,
    forceRflzSubmit = false,
}: FlexibleFormCustomSubmitArgs): FlexibleFormVariant['customSubmit'] {
    const formType = asset.fields.type.toLowerCase();

    if (formType === 'promocodeentry') {
        const promoCodeFieldName = asset.fields.form_fields.find(isPromoCodeFormField)?.fields.field_name;
        return createPromoCodeCustomSubmit(promoCodeFieldName);
    }

    const shouldUseRflzSubmit = forceRflzSubmit || formType === 'rflz';

    if (!shouldUseRflzSubmit) {
        return undefined;
    }

    if (isLicensePlateFormAsset(asset)) {
        return createLicensePlateCustomSubmit(asset.fields.form_fields);
    }

    return createRflzCustomSubmit(getRequiredRflzFieldNames(asset.fields.form_fields));
}
